// Stained-glass / heritage farm illustrations supplied by the customer.
// Used across the Heritage Dahlias home + landing tile + portal hero banners.
export const HERITAGE_ASSETS = {
  // SUNSET Mum's Shed, single dedicated scene, no inset text panels.
  // Replaces the older composite image and is used everywhere the big farm
  // panorama appears (Dahlias hero, landing tile, portal banners, etc.).
  heroScene:
    "https://customer-assets.emergentagent.com/job_apparel-dahlias/artifacts/1ml3lcp5_file_00000000072471faaa1f1943e9807e64.png",
};
